import { FC, memo } from 'react'

import { CompanyMultiSelect, Validators } from 'ui/components'
import { ChoiceOption } from 'ui/types'

import * as SC from './styles'

type Props = {
  isModeCreating: boolean
  Field: any
  relationshipsToAssign: ChoiceOption[]
}

export const AssignedRelationshipsForm: FC<Props> = memo(({ Field, isModeCreating, relationshipsToAssign }) => (
  <SC.Wrapper $biggerTopPadding={!isModeCreating}>
    <SC.Title>Assign Relationships</SC.Title>
    <SC.InputWrapper>
      <Field
        name="assignedRelationships"
        label="Relationships"
        required
        validator={Validators.required.array('At least one relationship is required')}
        input={CompanyMultiSelect}
        inputProps={{
          'data-qa': 'Assigned Companies',
          data: relationshipsToAssign,
          portal: 'bank'
        }}
      />
    </SC.InputWrapper>
  </SC.Wrapper>
))
